import DashboardAPI from '@/apis/business/student/dashboard-api.js'
import SubmitDetailAPI from '@/apis/business/student/submit-detail-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,
  state: {
    saveDraftExercise: null,
    statisticalExercise: null,
    exerciseResult: null,
    rankingPractive: null,
    widthChart: 0,
    dashboardViewMode: 0,
    studyHardworking: [],
    individualEvaluate: null,
    rankingStarNotify: null,
    showNotifyRanking: true,
    studentClassroomEMIS: null,
    studyHardworkingParam: null
  },
  mutations: {
    /**
     * @description reset dữ liệu
     * @author VDDung1
     * @param {*} state
     */
    clearData (state) {
      state.saveDraftExercise = null
      state.statisticalExercise = null
      state.exerciseResult = null
      state.rankingPractive = null
      state.widthChart = 0
    },
    /**
     * @description lưu dữ liệu bài lưu nháp gần nhất
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setSaveDraftExercise (state, data) {
      state.saveDraftExercise = data
    },
    /**
     * @description lưu dữ liệu thống kê bài tập học sinh
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setStatisticalExercise (state, data) {
      state.statisticalExercise = data
    },

    /**
     * @description lưu dữ liệu một số bài làm gần đây
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setExerciseResult (state, data) {
      state.exerciseResult = data
    },

    /**
     * @description lưu dữ liệu thứ hạng trong tuần trước
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setRankingPractiveOfLastWeek (state, data) {
      state.rankingPractive = data
    },

    /**
     * @description gán giá trị width cho từng biểu đồ
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setWidthChart (state, data) {
      state.widthChart = data
    },

    /**
     * @description set mode màn hình tổng quan học sinh
     * @param {*} state
     * @param {*} viewMode
     */
    setDashboardViewMode (state, viewMode) {
      state.dashboardViewMode = viewMode
    },

    /**
     * @description set giá trị bảng vinh danh
     * @author VDDung1
     */
    setStudyHardworking (state, data) {
      state.studyHardworking = data.slice(0, 5)
    },

    /**
     * @description set giá trị bảng đánh giá học tập hàng tháng
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setIndividualEvaluate (state, data) {
      state.individualEvaluate = data
    },

    /**
     * @description lấy danh sách thứ hạng hiển thị thông báo tặng sao
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setRankingStarNotify (state, data) {
      state.rankingStarNotify = data
    },

    /**
     * @description show notify star ranking
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setShowNotifyRanking (state, data) {
      state.showNotifyRanking = data
    },

    /**
     * @description set thông tin lớp chính quy của học sinh
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setStudentClassroomEMIS (state, data) {
      state.studentClassroomEMIS = data
    },

    /**
     * @description set giá trị param cho màn hình vinh danh tuần
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setStudyHardworkingParam (state, data) {
      state.studyHardworkingParam = data
    }
  },
  getters: {},
  actions: {
    /**
     * @description Lấy ra một bài lưu nháp gần nhất của học sinh
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     */
    async getOneSaveDraftExercise (context) {
      const res = await DashboardAPI.getAsync('savedraft-exercise')
      if (res.IsSuccess && res.Code === HttpStatusCode.OK && res.Data) {
        context.commit('setSaveDraftExercise', res.Data)
      }
    },

    /**
     * @description Lấy ra thống kê bài tập học sinh
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     */
    async getStatisticalExercise (context) {
      const res = await DashboardAPI.getAsync('statistical-exercise')
      if (res.IsSuccess && res.Code === HttpStatusCode.OK && res.Data) {
        context.commit('setStatisticalExercise', res.Data)
      }
    },

    /**
     * @description lấy ra xếp hạng làm bài trong tuần trước đó
     * @author VDDung1
     * @param {*} context
     */
    async getRankingPractiveOfLastWeek (context, param) {
      const res = await DashboardAPI.postAsync('ranking-practice', param)
      if (
        res.IsSuccess &&
        res.Code === HttpStatusCode.OK &&
        res.Data &&
        res.Data.length
      ) {
        context.commit('setRankingPractiveOfLastWeek', res.Data)
      }
    },

    /**
     * @description lấy ra một số bài đã làm gần đây
     * @author VDDung1
     * @param {*} context
     */
    async getExerciseSubmitResult (context, param) {
      const res = await DashboardAPI.getAsync(
        `exercise-result?countExercise=${param.countExercise}`
      )
      if (
        res.IsSuccess &&
        res.Code === HttpStatusCode.OK &&
        res.Data &&
        res.Data.length
      ) {
        context.commit('setExerciseResult', res.Data)
      }
    },

    /**
     * @description lấy dữ liệu bảng vinh danh
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     */
    async getStudyHardworkingOverview (context, param) {
      const res = await SubmitDetailAPI.getAsync('study-hardworking-overview', {
        params: param
      })
      if (res.IsSuccess && res.Code === HttpStatusCode.OK && res.Data) {
        context.commit('setStudyHardworking', res.Data)
      }
    },

    /**
     * @description lấy dữ liệu đánh giá hàng tháng
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     */
    async getIndividualEvaluate (context, param) {
      const res = await SubmitDetailAPI.getAsync('individual-evaluate', {
        params: param
      })
      if (res.IsSuccess && res.Code === HttpStatusCode.OK && res.Data) {
        context.commit('setIndividualEvaluate', res.Data)
      } else {
        context.commit('setIndividualEvaluate', null)
      }
    },

    /**
     * @description lấy dữ liệu đánh giá hàng tháng
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     */
    async upsertSubmitDetailHocmai (context, param) {
      return await SubmitDetailAPI.postAsync('upsert-hocmai', param)
    },

    /**
     * @description lấy thông tin thứ hạng hiển thị thông báo tặng sao
     * @author VDDung1
     * @param {*} context
     */
    async getRankingStarNotify (context) {
      const res = await DashboardAPI.getAsync('ranking-star-notify')
      if (res.IsSuccess && res.Code === HttpStatusCode.OK && res.Data) {
        context.commit('setRankingStarNotify', res.Data)
      } else {
        context.commit('setRankingStarNotify', null)
      }
    },

    /**
     * @description Cập nhật thông tin đã xem thông báo tặng sao xếp hạng
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     */
    async updateNotifyStarRanking (context, param) {
      await DashboardAPI.postAsync('star-notify', param)
    },

    /**
     * @description lấy thông tin lớp chính quy của học sinh
     * @author VDDung1
     */
    async getStudentClassroomEMIS (context) {
      const res = await DashboardAPI.getAsync('student-classroom-EMIS')
      if (res.IsSuccess && res.Code === HttpStatusCode.OK && res.Data) {
        context.commit('setStudentClassroomEMIS', res.Data)
      }
    }
  }
}
